import { Center } from "@chakra-ui/react";
import { BookBar, DateSearchBar, ReserveRoomList } from "@domains/components";
import { useSetIsPaidRoom } from "@shared/client";
import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { CustomTitle, CustomWrapper } from "./reserve.style";

export const Reserve = () => {
    const setPaidRoomValue = useSetIsPaidRoom();

    useEffect(() => {
        setPaidRoomValue(false);
    }, []);

    return (
        <>
            <Helmet>
                <title>Marginmax | 예약하기</title>
            </Helmet>
            <Center w="100%" flexDir={"column"} gap="16px">
                <CustomWrapper>
                    <DateSearchBar />
                    <CustomTitle as="h2">객실 선택</CustomTitle>
                    <ReserveRoomList />
                </CustomWrapper>
                <BookBar />
            </Center>
        </>
    );
};
